var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_vm._t("default"),(_vm.block)?_c('div',{staticClass:"elm-block",style:(_vm.style)}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }